import { render, staticRenderFns } from "./CustomerComponent.vue?vue&type=template&id=7d218e88&scoped=true"
import script from "./CustomerComponent.vue?vue&type=script&lang=js"
export * from "./CustomerComponent.vue?vue&type=script&lang=js"
import style0 from "./CustomerComponent.vue?vue&type=style&index=0&id=7d218e88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d218e88",
  null
  
)

export default component.exports